export default "__VITE_ASSET__B6bO6hob__"